import axiosInstance from "../api/api";

const SummaryService = {
    list: function (dateFrom, dateTo) {
        let url = "/api/summary/";
        const params = new URLSearchParams();
        if (dateFrom) params.append("dateFrom", dateFrom);
        if (dateTo) params.append("dateTo", dateTo);
        if (params.toString()) url += `?${params.toString()}`;
        
        return axiosInstance({
            url: url,
            method: "GET",
        });
    },
    fetch: function (uniqueId) {
        return axiosInstance({
            url: `/api/summary/${uniqueId}`,
            method: "GET",
        });
    },
    delete: function (uniqueId) {
        return axiosInstance({
            url: `/api/summary/${uniqueId}`,
            method: "DELETE",
        });
    },
    create: function (formData) {
        return axiosInstance({
            url: `/api/summary/`,
            method: "POST",
            data: formData,
        });
    },
    update: function (formData) {
        return axiosInstance({
            url: `/api/summary/`,
            method: "PATCH",
            data: formData,
        });
    },
};
export default SummaryService;
